// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import * as fbfire from "firebase/firestore"; // <-- add this
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDhneiQFuJ9G75pFxp97shb2zCwnlD0rIo",
  authDomain: "purchase-tracker-praneesh123.firebaseapp.com",
  projectId: "purchase-tracker-praneesh123",
  storageBucket: "purchase-tracker-praneesh123.firebasestorage.app",
  messagingSenderId: "944421073353",
  appId: "1:944421073353:android:de426ee6d2b77f3aedf818"
};

export const firebaseProjectId = firebaseConfig.projectId;

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

/**
 * Initialise Firestore with IndexedDB-backed offline persistence.
 *
 * Why: large lists like `items` and `groups` were re-downloaded from the cloud
 * on every page load / Find Item click, which made the modal feel laggy on
 * first open after login. With persistent cache enabled, subsequent loads are
 * served from the browser's IndexedDB and Firestore only fetches the diff.
 *
 * `persistentMultipleTabManager` lets the cache be shared safely between
 * tabs (the user often has billing + product pages open simultaneously).
 *
 * If the browser doesn't support IndexedDB (private mode in some browsers,
 * or older Safari), we fall back to the default in-memory store automatically.
 */
let _db;
try {
  _db = initializeFirestore(app, {
    localCache: persistentLocalCache({
      tabManager: persistentMultipleTabManager(),
    }),
  });
} catch (err) {
  console.warn(
    "[firebase] persistent cache unavailable, falling back to memory:",
    err?.message || err
  );
  // Fallback: lazy-load the default getter so we never crash boot.
  // eslint-disable-next-line global-require
  const { getFirestore } = require("firebase/firestore");
  _db = getFirestore(app);
}
export const db = _db;
// IMPORTANT: region must match deployed functions region
export const functions = getFunctions(app, "us-central1");

// 👇 debug വേണ്ടി global expose (development only)
// expose db + firestore helper functions so we can run queries from DevTools console
if (typeof window !== "undefined") {
  window.auth = auth;
  window.db = db;
  window.fbfire = fbfire; // <-- add this line
}
